import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { KeyFilterModule } from 'primeng/keyfilter';
import { AutocompleteModule } from '../basic-elements/autocomplete/autocomplete.module';
import { datePickerModule } from '../basic-elements/calendar/datepicker.module';
import { DropDownModule } from '../basic-elements/drop-down/drop-down.module';
import { BasicFileUploadModule } from '../basic-elements/file-upload/file-upload.module';
import { MultipleSelectDropDownWithSearchModule } from '../basic-elements/multiple-select-drop-down-with-search/multiple-select-drop-down-with-search.module';
import { MultipleSelectDropDownModule } from '../basic-elements/multiple-select-drop-down/multiple-select-drop-down.module';
import { PhoneNumberModule } from '../basic-elements/phone-number/phone-number.module';
import { NudgesModalComponent } from './nudges-modal/nudges-modal.component';
import { ProfileNudgeComponent } from './profile-nudges/profile-nudge/profile-nudge.component';
import { CommonNudgeComponent } from './common-nudge/common-nudge/common-nudge.component';
@NgModule({
  declarations: [
    NudgesModalComponent,
    ProfileNudgeComponent,
    CommonNudgeComponent
  ],
  imports: [
    CommonModule,
    ModalModule,
    DropDownModule,
    datePickerModule,
    BasicFileUploadModule,
    AutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    KeyFilterModule,
    InputTextModule,
    CalendarModule,
    MultipleSelectDropDownModule,
    MultipleSelectDropDownWithSearchModule,
    PhoneNumberModule
  ],
  exports: [
    NudgesModalComponent,
    ProfileNudgeComponent,
    CommonNudgeComponent
  ]
})
export class NudgesModule { }
